import { EOrderStatus } from '@mahawi/eshop-common/src/types';
import React from 'react';

import OrderLayout from '../../components/orders/orders-layout';

function OrdersDeliveredContainer(): React.ReactElement {
  return <OrderLayout orderStatusTypeCodes={[EOrderStatus.DELIVERED]} />;
}

export default OrdersDeliveredContainer;
